import script from "./purchase.vue?vue&type=script&setup=true&lang=js"
export * from "./purchase.vue?vue&type=script&setup=true&lang=js"

import "./purchase.vue?vue&type=style&index=0&id=ed1f92ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed1f92ba"]])

export default __exports__